import { translations } from "../../i18n";

type Translation = (typeof translations)["de"];

function HowItWorks({
  isVisible,
  t,
}: {
  isVisible: (id: string) => boolean;
  t: Translation["how"];
}) {
  return (
    <section
      id="how"
      data-animate
      className={`py-16 sm:py-24 md:py-32 transition-all duration-1000 ${
        isVisible("how")
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-10"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-10 sm:mb-14 md:mb-20">
          {t.heading}
        </h2>

        <div className="grid md:grid-cols-3 gap-8 sm:gap-10 md:gap-12">
          {t.steps.map((step) => (
            <div
              key={step.num}
              className="relative text-center group cursor-pointer"
            >
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-orange-500 rounded-full flex items-center justify-center text-xl sm:text-2xl font-bold mx-auto mb-4 sm:mb-6 relative z-10 group-hover:scale-110 group-hover:rotate-12 transition-all duration-300 group-hover:shadow-2xl group-hover:shadow-orange-500/50">
                {step.num}
              </div>
              <h3 className="text-xl sm:text-2xl font-semibold mb-2 sm:mb-4 group-hover:text-orange-500 transition-colors">
                {step.title}
              </h3>
              <p className="text-slate-400 text-base sm:text-lg group-hover:text-slate-300 transition-colors">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;